/*
 * Copyright (c) 2024. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import {hot} from "react-hot-loader";
import AlertResponder from "components/AlertResponder";
import Loader from "components/Loader";
import React from "react";
import {Route, Switch} from "react-router-dom";
import "./App.scss";
import "react-toastify/dist/ReactToastify.css";
import FrontLayout from "./layouts/FrontLayout";
import {Helmet} from "react-helmet";
import {useTypedSelector} from "helpers/reducers";
import LogRocket from "logrocket";
import setupLogRocketReact from "logrocket-react";

const dayOfMonth = new Date().getDate();
const kioskCode = dayOfMonth <= 10 ? 1 : dayOfMonth <= 20 ? 2 : 3;

LogRocket.init("arboparkonline" + kioskCode + "/online");
setupLogRocketReact(LogRocket);

const App = () => {
    const language = useTypedSelector(state => state.sessionState.language);

    return (
        <div className="App min-h-full w-full flex flex-col overflow-x-hidden">
            <Helmet>
                <html lang={language?.code || "de"} />
                <title id="site-title">Booking | ArboPark – Action & Fun Center</title>
            </Helmet>
            <>
                <Loader usereducer={true} />
                <Switch>
                    <Route path={"/"}>
                        <FrontLayout />
                    </Route>
                </Switch>
                <AlertResponder />
            </>
        </div>
    );
};

export default hot(module)(App);
